var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner",on:{"click":function($event){return _vm.$router.push('/menu')}}},[_c('img',{staticClass:"desktop",attrs:{"src":require("assets/s-images/delivery/slide-nory.png"),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }